<template>
  <div class="sporadicIndex">
    <el-container>
      <el-header>
        <el-form class="engineeringForm" :inline="true" :model="dataForm" label-width="100px">
          <el-row>
            <el-col :span="6">
              <el-form-item label-width="80px" label="项目：">
                <el-select v-model="dataForm.projectId" placeholder="请选择项目" @change="getSubInfoByProjectIdList">
                  <el-option :label="allProjectItem.name" :value="allProjectItem.id" v-for="(allProjectItem,allProjectIndex) in allProjectList" :key="'allProject'+allProjectIndex"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="80px" label="合作单位：">
                <el-select v-model="dataForm.partyBId" placeholder="请选择合作单位" clearable>
                  <el-option :label="subInfoItem.partyB" :value="subInfoItem.partyBId" v-for="(subInfoItem,subInfoIndex) in subInfoList" :key="'subInfoItem'+subInfoIndex" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="80px" label="合同编号：">
                <el-input v-model="dataForm.subContractSerialNumber" placeholder="请输入合同编号" clearable></el-input>
              </el-form-item>
            </el-col>
            <div v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label-width="80px" label="提报部门：">
                  <el-select v-model="dataForm.applyDeptId" placeholder="请选择提报部门">
                    <el-option :label="applyDeptItem.applyDeptName" :value="applyDeptItem.applyDeptId" v-for="(applyDeptItem,applyDeptIndex) in applyDeptList" :key="'applyDeptItem'+applyDeptIndex"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="80px" label="提报人：">
                  <el-input v-model="dataForm.applyUserName" placeholder="请输入提报人" clearable></el-input>
                </el-form-item>
              </el-col>
            </div>
            <el-col :span="showAdvanceFilter ? 18 : 6" class="btnRight">
              <el-form-item class="btnList">
                <el-button type="primary" @click="query()">查 询</el-button>
                <el-button type="info" @click="reset()">重 置</el-button>
                <el-button type="text" @click="showAdvanceFilter = !showAdvanceFilter">{{showAdvanceFilter?'收起':'高级筛选'}}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row>
          <el-col :span="24">
            <div class="operatePanel">
              <el-button
                      v-if="btnAuthorize.create.btnEnable"
                      style="margin-top: 10px;margin-left: 0px"
                      type="primary"
                      @click="goToAddAndModiify(1)"
              >新增</el-button>
              <el-button
                      v-if="btnAuthorize.update.btnEnable"
                      style="margin-top: 10px;margin-left: 0px"
                      type="primary"
                      @click="goToAddAndModiify(2)"
              >修改</el-button>
              <el-button
                      v-if="btnAuthorize.delete.btnEnable"
                      style="margin-top: 10px;margin-left: 0px"
                      type="primary"
                      @click="handleDeleteClick()"
              >删除</el-button>
              <el-button
                      v-if="btnAuthorize.callback.btnEnable"
                      style="margin-top: 10px;margin-left: 0px"
                      type="primary"
                      @click="handleWithdrawClick()"
              >撤回</el-button>
              <el-button
                      v-if="btnAuthorize.export.btnEnable"
                      style="margin-top: 10px;margin-left: 0px"
                      type="primary"
                      @click="handleExportClick()"
              >导出</el-button>
              <el-button
                      v-if="btnAuthorize.export.btnEnable"
                      style="margin-top: 10px;margin-left: 0px"
                      type="primary"
                      @click="handleAllExportClick()"
              >导出全部</el-button>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main ref="main">
        <el-table
            ref="dataTable"
            :data="sporadicList"
            highlight-current-row
            @selection-change="handleSelectionChange"
            @cell-dblclick="dblclickDetail"
            size="mini"
            height="100%"
            border
        >
          <el-table-column
                  type="selection"
                  width="55">
          </el-table-column>
          <el-table-column
              prop="subContractSerialNumber"
              label="合同编号"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="projectName"
              label="项目名称"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="partyB"
              label="合作单位"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="applyUserName"
              label="提报人"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="applyDeptName"
              label="提报部门"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="createTime"
              label="提报时间"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="approveStatusShow"
              label="审批状态"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="innerGroupCheckStatusShow"
              label="内部定额小组确认"
              :show-overflow-tooltip="true"
          ></el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="dataForm.pageIndex"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="dataForm.pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import {
  getSporadicListService,
  getAllProjectPassListService,
  queryApplyDeptListService,
  deleteSporadicProjectService,
  recallApproveProcessService,
  exportSporadicProjectService,
  exportAllSporadicProjectService,
} from "@/services/engineering";
import {
  getSubInfoByProjectId,
} from "@/services/financeService";
import {exportExcelService2} from "../../../services/allContractServices";

export default {
  name:'sporadic',
  data(){
    return {
      dataForm:{
        projectId: '',
        partyBId: '',
        subContractSerialNumber: '',
        applyDeptId: '',
        applyUserName: '',
        pageIndex: 1,
        pageSize: 10,
      },
      allProjectList: [],
      subInfoList: [],
      applyDeptList: [],
      sporadicList: [],
      total: 0,
      showAdvanceFilter: false,
      multipleSelection: [],

      btnAuthorize: {
        create: { key: "create", btnEnable: false },
        update: { key: "update", btnEnable: false },
        delete: { key: "delete", btnEnable: false },
        callback: { key: "callback", btnEnable: false },
        export: { key: "export", btnEnable: false },
      },
    }
  },
  methods: {
    onActive(menuCode) {
      console.log(menuCode)
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.getSporadicList();
      this.getAllProjectPassList();
      this.queryApplyDeptList();
    },
    //根据条件查询
    query(){
      this.dataForm.pageIndex = 1;
      this.getSporadicList();
    },
    reset(){
      this.dataForm = {
        projectId: '',
        partyBId: '',
        subContractSerialNumber: '',
        applyDeptId: '',
        applyUserName: '',
        pageIndex: 1,
        pageSize: 10,
      };
      this.sporadicList = [];
      this.subInfoList = [];
      this.getSporadicList();
    },
    /**
     * 获取列表数据
     * */
    getSporadicList(){
      let paramsData = {
        ...this.dataForm
      }
      getSporadicListService(paramsData).then( res => {
        if(res.code == 10000000){
          this.sporadicList = res.data;
          this.total = res.total;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    getAllProjectPassList(){
      getAllProjectPassListService().then( res => {
        if(res.code == 10000000){
          this.allProjectList = res.data;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    getSubInfoByProjectIdList(){
      let params = {
        projectId: this.dataForm.projectId
      }
      getSubInfoByProjectId(params).then( res => {
        if(res.code == 10000000){
          this.subInfoList = res.data;
          this.dataForm.partyBId = '';
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    queryApplyDeptList(){
      queryApplyDeptListService().then( res => {
        if(res.code == 10000000){
          this.applyDeptList = res.data;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    dblclickDetail(row, column, cell, event) {
      this.bus.$emit("navMenuChange", {
        routeId: "sporadicDetail",
        routeParam: {
          id: row.id
        }
      });
    },
    // 新增
    goToAddAndModiify(sporadicType,item = null){
      if(sporadicType == 1){
        this.bus.$emit("navMenuChange", {
          routeId: "sporadicAdd",
          routeParam: {
            id: '',
            sporadicType: sporadicType
          }
        });
      }else {
        if(this.multipleSelection.length != 1){
          this.$message.error('请选择一条修改的零星工程量数据')
          return
        }

        if(this.multipleSelection[0].approveStatus == 2 ||this.multipleSelection[0].approveStatus == 3){
          this.$message.error('请选择一条可修改的零星工程量数据')
          return
        }
        this.bus.$emit("navMenuChange", {
          routeId: "sporadicModify",
          routeParam: {
            id: this.multipleSelection[0].id,
            sporadicType: sporadicType
          }
        });
      }
    },
    // 删除
    handleDeleteClick(){
      if(this.multipleSelection.length == 0){
        this.$message.error('请选择删除的零星工程量数据')
        return
      }
      let isIndex = this.multipleSelection.findIndex(item => item.approveStatus == 2 || item.approveStatus == 3)
      if(isIndex != -1){
        this.$message.error('审批状态为待审核、已通过的单据不能删除')
        return
      }
      let delIds = this.multipleSelection.map(item => item.id)
      this.$confirm('此操作将永久删除零星工程量数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          delIds
        }
        deleteSporadicProjectService(params).then(res => {
          if (res.code == 10000000){
            this.$message.success('删除成功！')
            this.query();
          }
        })
      }).catch(() => {

      });
    },
    // 撤回
    handleWithdrawClick(){
      if(this.multipleSelection.length != 1){
        this.$message.error('请选择一条撤回的零星工程量数据')
        return
      }
      this.$confirm("确定要撤回吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          itemId : this.multipleSelection[0].id,
          type: 'SPORADIC_PROJECT'
        }
        recallApproveProcessService(params).then( res => {
          if(res.code == 10000000){
            this.$message.success('撤回成功');
            this.query();
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      });
    },
    // 导出选定条目
    handleExportClick(){
      if(this.multipleSelection.length == 0){
        this.$message.error('至少选择一条零星工程量数据导出')
        return
      }
      let exportIds = this.multipleSelection.map(item => item.id)

      let params = {
        exportIds
      }
      exportSporadicProjectService(params).then( res => {
        if(res.code == 10000000){
          exportExcelService2(res.data).then(res1 => {
            this.$message.success('下载成功');
          });
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 导出全部条目
    handleAllExportClick(){
      let params = {
        ...this.dataForm
      }
      exportAllSporadicProjectService(params).then( res => {
        if(res.code == 10000000){
          exportExcelService2(res.data).then(res1 => {
            this.$message.success('下载成功');
          });
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 分页改变事件
    handleCurrentChange(page) {
      this.dataForm.pageIndex = page;
      this.getSporadicList();
    },
    // 分页显示数量改变事件
    handleSizeChange(rows) {
      this.dataForm.pageIndex = 1;
      this.dataForm.pageSize = rows;
      this.getSporadicList();
    },
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.sporadicIndex {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
/deep/.el-form-item__content{
  height: 40px;
}
.btnRight {
  display: flex;
  justify-content: flex-end;
  .btnList{
    text-align: right;
  }
  /deep/.el-form-item__content{
    height: auto;
  }
}
</style>
